import * as dto from 'client/dto';

export interface AdditiveSearchCategory<T> {
  name: string;
  values: AdditiveSearchCategoryOption<T>[];
}

export interface AdditiveSearchCategoryOption<T> {
  id: number;
  name: string;
  disabled?: boolean;
  data?: T;
}

enum CustomLocationType {
  Airport = 99,
}

export type LocationType = dto.LocationType | CustomLocationType;

export const LocationSearchType = {
  ...dto.LocationType,
  ...CustomLocationType,
};

/** Model that result of various APIs (usually Azure) are mapped to for consistency */
export interface LocationSearchResult {
  id: number;
  displayName: string;
  locationType: LocationType;
  name: string;
  countryName: string;
  provinceName: string;
  countryId?: number;
  airportCode?: string;
  cityName?: string;
  hasCounties?: boolean;
  hasProvinces?: boolean;
}

/** Model used by the location chip */
export type LocationInfo = {
  id: number;
  name: string;
  displayName: string;
  provinceName?: string;
  countryName?: string;
  locationType: LocationType;
  color?: string;
};

export type GeonameCategory = AdditiveSearchCategory<LocationSearchResult>;
export type GeonameOption = AdditiveSearchCategoryOption<LocationSearchResult>;

export type GeonameModelWithCode = dto.GetGeonameModel & { code?: string };
